import Svg from "components/Hero/parts/Svg";
import { isDayTime } from "utils/helper";

export const clouds = isDayTime() ? (
	<Svg
		className="clouds-days"
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 111.11000000000001"
		enable-background="new 0 0 100 88.888"
	>
		<path
			fill="#f9f1eb"
			d="M96.295,48.146h-7.408c-2.045,0-3.704-1.657-3.704-3.703c0-2.045,1.659-3.701,3.704-3.701h7.408
	c2.044,0,3.704,1.658,3.704,3.701C100,46.489,98.339,48.146,96.295,48.146z"
		/>
		<path
			fill="#f9f1eb"
			d="M81.744,23.492c-1.447,1.446-3.791,1.446-5.238,0c-1.447-1.445-1.447-3.791,0-5.236l5.238-5.238
	c1.446-1.446,3.791-1.446,5.237,0c1.447,1.445,1.447,3.792,0,5.238L81.744,23.492z"
		/>
		<path
			fill="#f9f1eb"
			d="M76.285,52.396c0.947-2.471,1.49-5.147,1.494-7.953c0-12.27-9.951-22.222-22.226-22.222
	c-7.142,0-13.481,3.384-17.547,8.619c-2.653-0.781-5.465-1.21-8.377-1.21C13.266,29.63,0,42.895,0,59.258
	c0,16.365,13.266,29.63,29.629,29.63c5.921,0,24.491,0,29.628,0c12.274,0,22.226-9.951,22.226-22.222
	C81.483,61.232,79.526,56.259,76.285,52.396z M55.553,29.63c8.183,0,14.817,6.634,14.817,14.813c0,0.969-0.102,1.912-0.279,2.828
	c-3.204-1.793-6.897-2.828-10.834-2.828c-1.289,0-2.535,0.17-3.766,0.38C53.003,40.375,49.4,36.64,45.067,33.98
	C47.747,31.293,51.456,29.63,55.553,29.63z M59.257,81.48c-5.592,0-22.933,0-29.63,0c-12.273,0-22.221-9.948-22.221-22.222
	s9.948-22.22,22.221-22.22c10.541,0,19.325,7.358,21.604,17.204c2.315-1.498,5.062-2.392,8.026-2.392
	c8.183,0,14.813,6.635,14.813,14.816C74.071,74.846,67.44,81.48,59.257,81.48z"
		/>
		<path
			fill="#f9f1eb"
			d="M55.553,14.813c-2.045,0-3.704-1.658-3.704-3.702V3.704c0-2.046,1.66-3.704,3.704-3.704
	c2.046,0,3.704,1.658,3.704,3.704v7.407C59.257,13.157,57.601,14.813,55.553,14.813z"
		/>
		<path
			fill="#f9f1eb"
			d="M29.365,23.492l-5.236-5.236c-1.447-1.446-1.447-3.793,0-5.238c1.444-1.446,3.791-1.446,5.236,0l5.237,5.238
	c1.447,1.445,1.447,3.791,0,5.236C33.158,24.938,30.811,24.938,29.365,23.492z"
		/>
	</Svg>
) : (
	<Svg
		className="clouds-night"
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 108.3375"
		enable-background="new 0 0 100 86.67"
	>
		<path
			fill="#f9f1eb"
			d="M92.937,44.706L92.937,44.706c3.039,4.333,4.841,9.599,4.841,15.298c0,14.725-11.938,26.666-26.667,26.666
c-6.166,0-28.449,0-35.555,0C15.917,86.67,0,70.752,0,51.113c0-19.637,15.917-35.555,35.556-35.555c4.45,0,8.699,0.833,12.625,2.327
l0,0C51.816,7.479,61.689,0,73.333,0c1.68,0,3.316,0.174,4.905,0.471c-0.291,1.278-0.46,2.607-0.46,3.974
c0,9.819,7.961,17.778,17.776,17.778c1.371,0,2.695-0.169,3.976-0.462c0.298,1.593,0.47,3.229,0.47,4.908
C100,33.631,97.309,39.958,92.937,44.706z M8.887,51.113c0,14.729,11.938,26.667,26.666,26.667c8.038,0,28.847,0,35.558,0
c9.819,0,17.776-7.962,17.776-17.776c0-9.819-7.957-17.779-17.776-17.779c-3.558,0-6.854,1.071-9.632,2.869
c-2.737-11.815-13.276-20.647-25.926-20.647C20.825,24.446,8.887,36.386,8.887,51.113z M52.336,19.785c0.002,0,0.005,0,0.005,0
S52.338,19.785,52.336,19.785z M69.357,9.351c-6.443,1.476-11.499,6.467-13.166,12.835l0,0c4.263,3.05,7.829,7.005,10.401,11.603
c1.476-0.252,2.972-0.456,4.519-0.456c5.817,0,11.187,1.89,15.569,5.047l0,0c1.907-2.176,3.301-4.818,3.97-7.739
C79.863,28.631,71.367,20.143,69.357,9.351z"
		/>
	</Svg>
);

export const clear = isDayTime() ? (
	<Svg
		className="clear-day"
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 125"
		enable-background="new 0 0 100 100"
	>
		<path
			fill="#f9f1eb"
			d="M95.833,54.165h-8.33c-2.302,0-4.168-1.866-4.168-4.165c0-2.3,1.866-4.167,4.168-4.167h8.33
C98.134,45.833,100,47.7,100,50C100,52.299,98.139,54.165,95.833,54.165z"
		/>
		<path
			fill="#f9f1eb"
			d="M79.468,26.431c-1.628,1.626-4.271,1.626-5.894,0c-1.627-1.627-1.627-4.265,0-5.893l5.894-5.892
c1.621-1.627,4.265-1.627,5.893,0c1.621,1.627,1.621,4.265,0,5.892L79.468,26.431z"
		/>
		<path
			fill="#f9f1eb"
			d="M50.002,24.999c-13.81,0-25.003,11.193-25.003,25.001c0,13.806,11.195,24.999,25.003,24.999
S75.001,63.806,75.001,50C75.001,36.192,63.81,24.999,50.002,24.999z M50.002,66.667c-9.203,0-16.668-7.464-16.668-16.667
c0-9.205,7.463-16.667,16.668-16.667S66.667,40.795,66.667,50C66.667,59.203,59.205,66.667,50.002,66.667z"
		/>
		<path
			fill="#f9f1eb"
			d="M50.002,16.667c-2.302,0-4.167-1.867-4.167-4.167V4.167C45.835,1.867,47.7,0,50.002,0
c2.302,0,4.167,1.867,4.167,4.167V12.5C54.169,14.8,52.299,16.667,50.002,16.667z"
		/>
		<path
			fill="#f9f1eb"
			d="M20.538,26.431l-5.892-5.893c-1.627-1.626-1.627-4.265,0-5.892c1.627-1.627,4.265-1.627,5.892,0l5.893,5.892
c1.626,1.628,1.626,4.266,0,5.893C24.804,28.057,22.166,28.057,20.538,26.431z"
		/>
		<path
			fill="#f9f1eb"
			d="M16.667,50c0,2.299-1.867,4.165-4.167,4.165H4.165C1.865,54.165,0,52.299,0,50
c0-2.3,1.867-4.167,4.165-4.167H12.5C14.802,45.833,16.667,47.7,16.667,50z"
		/>
		<path
			fill="#f9f1eb"
			d="M20.538,73.57c1.628-1.626,4.266-1.626,5.893,0c1.626,1.626,1.626,4.265,0,5.893l-5.893,5.891
c-1.626,1.628-4.265,1.628-5.892,0c-1.627-1.625-1.627-4.265,0-5.891L20.538,73.57z"
		/>
		<path
			fill="#f9f1eb"
			d="M50.002,83.333c2.302,0,4.167,1.864,4.167,4.165v8.335c0,2.301-1.865,4.167-4.167,4.167
c-2.302,0-4.167-1.866-4.167-4.167v-8.335C45.835,85.197,47.7,83.333,50.002,83.333z"
		/>
		<path
			fill="#f9f1eb"
			d="M79.468,73.57l5.893,5.893c1.621,1.626,1.621,4.266,0,5.891c-1.628,1.628-4.271,1.628-5.893,0l-5.894-5.891
c-1.627-1.628-1.627-4.267,0-5.893C75.196,71.942,77.835,71.942,79.468,73.57z"
		/>
	</Svg>
) : (
	<Svg
		className="clear-night"
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 125"
		enable-background="new 0 0 100 100"
	>
		<path
			fill="#f9f1eb"
			d="M50.002,100C22.386,100,0,77.614,0,50.002C0,22.386,22.386,0,50.002,0c3.146,0,6.214,0.326,9.197,0.883
c-0.549,2.401-0.866,4.887-0.866,7.451c0,18.41,14.927,33.333,33.337,33.333c2.56,0,5.051-0.317,7.451-0.867
c0.554,2.987,0.879,6.051,0.879,9.201C100,77.614,77.614,100,50.002,100z M42.551,17.531c-14.817,3.388-25.882,16.622-25.882,32.471
c0,18.407,14.923,33.333,33.333,33.333c15.842,0,29.081-11.065,32.466-25.882C62.243,53.685,46.315,37.759,42.551,17.531z"
		/>
	</Svg>
);

export const snow = (
	<Svg
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 113.63749999999999"
		enable-background="new 0 0 100 90.91"
	>
		<path
			fill="#f9f1eb"
			d="M81.819,71.145v-9.957c5.431-3.15,9.089-9.008,9.089-15.734c0-10.039-8.14-18.18-18.182-18.18
c-3.638,0-7.007,1.091-9.849,2.934C60.081,18.123,49.298,9.09,36.363,9.09C21.3,9.09,9.092,21.303,9.092,36.366
c0,8.067,3.524,15.295,9.092,20.285v11.174C7.326,61.532,0,49.818,0,36.366C0,16.282,16.282,0,36.363,0
C50.01,0,61.887,7.528,68.105,18.648c1.51-0.257,3.039-0.466,4.621-0.466C87.79,18.182,100,30.395,100,45.454
C100,57.326,92.4,67.394,81.819,71.145z"
		/>
		<circle fill="#f9f1eb" cx="31.817" cy="59.092" r="4.546" />
		<path
			fill="#f9f1eb"
			d="M31.817,72.73c2.512,0,4.546,2.035,4.546,4.546s-2.034,4.542-4.546,4.542c-2.509,0-4.544-2.033-4.544-4.542
C27.273,74.763,29.308,72.73,31.817,72.73z"
		/>
		<circle fill="#f9f1eb" cx="50.001" cy="68.184" r="4.546" />
		<circle fill="#f9f1eb" cx="50.001" cy="86.364" r="4.546" />
		<circle fill="#f9f1eb" cx="68.18" cy="59.092" r="4.546" />
		<path
			fill="#f9f1eb"
			d="M68.18,72.73c2.511,0,4.546,2.035,4.546,4.546s-2.035,4.542-4.546,4.542c-2.51,0-4.543-2.033-4.543-4.542
C63.637,74.763,65.674,72.73,68.18,72.73z"
		/>
	</Svg>
);

export const defaultIcon = (
	<svg
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 90.9075"
		enable-background="new 0 0 100 72.726"
	>
		<path
			fill="#f9f1eb"
			d="M36.363,72.726C16.281,72.726,0,56.447,0,36.364C0,16.279,16.281,0,36.363,0
	c13.648,0,25.523,7.528,31.743,18.646c1.51-0.257,3.041-0.466,4.622-0.466C87.791,18.18,100,30.393,100,45.455
	c0,15.059-12.209,27.271-27.271,27.271C66.42,72.726,43.633,72.726,36.363,72.726z M72.729,63.634
	c10.042,0,18.184-8.143,18.184-18.18c0-10.041-8.142-18.183-18.184-18.183c-3.639,0-7.006,1.093-9.852,2.935
	C60.08,18.123,49.3,9.09,36.363,9.09C21.303,9.09,9.092,21.3,9.092,36.364c0,15.062,12.211,27.271,27.271,27.271
	C44.585,63.634,65.864,63.634,72.729,63.634z"
		/>
	</svg>
);

export const rain = (
	<Svg
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 99.998 125"
		enable-background="new 0 0 99.998 100"
	>
		<path
			fill="#f9f1eb"
			d="M81.818,71.14v-9.957c5.43-3.146,9.092-9.003,9.092-15.729c0-10.041-8.142-18.182-18.184-18.182
c-3.638,0-7.005,1.091-9.851,2.934C60.079,18.121,49.299,9.09,36.363,9.09C21.302,9.09,9.092,21.3,9.092,36.361
c0,8.067,3.526,15.292,9.092,20.285v11.174C7.326,61.528,0,49.813,0,36.361C0,16.279,16.281,0,36.363,0
C50.01,0,61.886,7.526,68.105,18.646c1.509-0.257,3.041-0.466,4.621-0.466c15.062,0,27.271,12.211,27.271,27.274
C99.998,57.324,92.406,67.394,81.818,71.14z"
		/>
		<path
			fill="#f9f1eb"
			d="M31.819,45.454c2.51,0,4.544,2.038,4.544,4.546v36.363c0,2.513-2.034,4.546-4.544,4.546
c-2.509,0-4.546-2.033-4.546-4.546V50C27.273,47.491,29.31,45.454,31.819,45.454z"
		/>
		<path
			fill="#f9f1eb"
			d="M50,54.546c2.509,0,4.547,2.035,4.547,4.546v36.362C54.548,97.965,52.51,100,50,100
s-4.546-2.035-4.546-4.546V59.092C45.455,56.579,47.491,54.546,50,54.546z"
		/>
		<path
			fill="#f9f1eb"
			d="M68.181,45.454c2.511,0,4.546,2.038,4.546,4.546v36.363c0,2.513-2.035,4.546-4.546,4.546
c-2.508,0-4.546-2.033-4.546-4.546V50C63.635,47.491,65.673,45.454,68.181,45.454z"
		/>
	</Svg>
);

export const drizzle = (
	<Svg
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 100 125"
		enable-background="new 0 0 100 100"
	>
		<path
			fill="#f9f1eb"
			d="M81.82,71.144v-9.958c5.425-3.149,9.088-9.003,9.088-15.729c0-10.043-8.138-18.185-18.18-18.185
c-3.643,0-7.011,1.093-9.852,2.935C60.075,18.123,49.3,9.089,36.363,9.089C21.3,9.089,9.092,21.3,9.092,36.363
c0,8.068,3.521,15.295,9.087,20.29v11.169C7.322,61.529,0,49.816,0,36.363C0,16.279,16.279,0,36.363,0
c13.648,0,25.523,7.528,31.743,18.646c1.51-0.257,3.037-0.466,4.622-0.466C87.791,18.179,100,30.392,100,45.457
C100,57.323,92.404,67.396,81.82,71.144z"
		/>
		<path
			fill="#f9f1eb"
			d="M31.817,45.457c2.509,0,4.546,2.036,4.546,4.546v9.087c0,2.513-2.037,4.546-4.546,4.546
c-2.512,0-4.546-2.033-4.546-4.546v-9.087C27.271,47.49,29.306,45.457,31.817,45.457z"
		/>
		<path
			fill="#f9f1eb"
			d="M31.817,72.729c2.509,0,4.546,2.035,4.546,4.546v9.087c0,2.513-2.037,4.547-4.546,4.547
c-2.512,0-4.546-2.034-4.546-4.547v-9.087C27.271,74.762,29.306,72.729,31.817,72.729z"
		/>
		<path
			fill="#f9f1eb"
			d="M49.997,54.544c2.512,0,4.547,2.038,4.547,4.546v9.093c0,2.51-2.035,4.546-4.547,4.546
c-2.509,0-4.542-2.036-4.542-4.546V59.09C45.456,56.582,47.49,54.544,49.997,54.544z"
		/>
		<path
			fill="#f9f1eb"
			d="M49.997,81.82c2.512,0,4.547,2.035,4.547,4.541v9.093c0,2.513-2.035,4.546-4.547,4.546
c-2.509,0-4.542-2.033-4.542-4.546v-9.093C45.456,83.854,47.49,81.82,49.997,81.82z"
		/>
		<path
			fill="#f9f1eb"
			d="M68.183,45.457c2.508,0,4.546,2.036,4.546,4.546v9.087c0,2.513-2.038,4.546-4.546,4.546
c-2.514,0-4.547-2.033-4.547-4.546v-9.087C63.636,47.49,65.669,45.457,68.183,45.457z"
		/>
		<path
			fill="#f9f1eb"
			d="M68.183,72.729c2.508,0,4.546,2.035,4.546,4.546v9.087c0,2.513-2.038,4.547-4.546,4.547
c-2.514,0-4.547-2.034-4.547-4.547v-9.087C63.636,74.762,65.669,72.729,68.183,72.729z"
		/>
	</Svg>
);

export const thunderstorm = (
	<Svg
		version="1.1"
		x="0px"
		y="0px"
		viewBox="0 0 99.999 125"
		enable-background="new 0 0 99.999 100"
	>
		<path
			fill="#f9f1eb"
			d="M72.724,72.729c-0.637,0-1.477,0-2.413,0l8.146-10.028c7.231-2.402,12.45-9.212,12.45-17.248
c0-10.041-8.14-18.178-18.182-18.178c-3.64,0-7.008,1.091-9.849,2.932C60.078,18.125,49.298,9.092,36.363,9.092
c-15.061,0-27.271,12.21-27.271,27.275c0,12.378,8.256,22.817,19.557,26.147L25.582,71.1C10.762,66.505,0,52.694,0,36.365
C0,16.284,16.281,0,36.363,0c13.646,0,25.522,7.528,31.742,18.648c1.509-0.26,3.041-0.466,4.621-0.466
c15.062,0,27.273,12.208,27.273,27.272C99.999,60.517,87.786,72.729,72.724,72.729z"
		/>
		<polygon
			fill="#f9f1eb"
			points="45.453,40.908 68.178,40.908 54.542,63.638 70.45,63.638 40.907,100 49.089,72.729 34.088,72.729 
"
		/>
	</Svg>
);
